import PropTypes from 'prop-types';
import React from 'react';
import { PaymentType } from '@wix/wix-vod-constants/api-types';
import { MessageWithPrice } from '../message-with-price/message-with-price';

const MESSAGES = {
  [PaymentType.PURCHASE]: 'widget.payments.purchase',
  [PaymentType.RENT]: 'widget.payments.rent',
  [PaymentType.SUBSCRIPTION]: 'widget.payments.subscription-month',
};

export default class DealInfo extends React.Component {
  static propTypes = {
    currency: PropTypes.string,
    price: PropTypes.number,
    type: PropTypes.string,
  };

  render() {
    const { type, price, currency } = this.props;
    const message = MESSAGES[type];
    if (!message) {
      return null;
    }

    return (
      <MessageWithPrice messageId={message} price={price} currency={currency} />
    );
  }
}
